import AmpleHireImageTag from "../../ample-hire-html-tags/ample-hire-image-tag";
import { Link } from "react-router-dom";

const EnhanceSectionIcon = ({
  iconSrc = "",
  altText = "",
  iconClassName = "",
  pText = "",
  onClick = () => {},
  active = false,
}) => {
  return (
    <li className={active ? "active" : ""} onClick={onClick}>
      <Link to="">
        <i>
          <AmpleHireImageTag
            className={iconClassName}
            src={iconSrc}
            alt={altText}
          />
        </i>
        <p>{pText}</p>
      </Link>
    </li>
  );
};

export default EnhanceSectionIcon;
